import { render, staticRenderFns } from "./EducationalScheduleTimeDetailsUserTable.vue?vue&type=template&id=f71ba8d8&"
import script from "./EducationalScheduleTimeDetailsUserTable.vue?vue&type=script&lang=js&"
export * from "./EducationalScheduleTimeDetailsUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports